import React, { useEffect, useRef, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Services } from '@/services/services';

import './Main.css'
import { Translates } from '@/services/repository/i18n';
import { MainPageLayout } from '@/components/layout/MainLayout';
import { Machine } from '@/services/model/machine';
import { CurrentSession } from '@/services/repository/session';
import { WizardData, LoadWizardData, SaveWizardData, categories } from './Model';
import { BackButton } from '@/components/layout/NavBar';
import { FilesProvider, SimpleFiles } from '@/components/forms/common/files/files';
import { Stream } from '@/services/common/stream';
import * as osfiles from "@/components/forms/common/osfiles"

const API_BASE = "/api/public/tmp/files"

/* Select category */

export const SupportWizardStep2 = ({ services, session }: { services: Services, session?: CurrentSession }) => {
  const navigate = useNavigate()
  const [translates, setTranslates] = useState<Translates>()
  const [wizardData, setWizardData] = useState<WizardData>(LoadWizardData())

  useEffect(() => {
    if (session) {
      setTranslates(session.translates)
      return
    }
    services.i18n.get('main').then(setTranslates)
  }, [session])

  useEffect(() => {
    const id = wizardData.categoryId
    if(!id) {
      navigate(`/communal/support/wizard/page1`, { replace: true })
    }
  }, [wizardData.categoryId])

  if (translates === undefined || wizardData === undefined) {
    return <div className='spinner'></div>
  }

  return <MainPageLayout pageName='support-wizard' services={services} translates={translates} session={session}
    navbarLeft={
      <BackButton
        services={services}
        translates={translates}
        fallbackUrl={`/communal/support/wizard/page1`}
      />
    }>

    <h2 className='page-title'>{translates.for(`wizards.support_question.title`)}</h2>

    {categories.find((row) => row.id === wizardData.categoryId)?.issues.map(row => <div className={`main-btn ${wizardData.issueId === row.id ? 'selected' : ''}`} onClick={() => {
      const newData = {
        ...wizardData,
        issueId: row.id
      }
      setWizardData(newData)
      SaveWizardData(newData)
      navigate(`/communal/support/wizard/page3`)
    }}>{translates.for(`wizards.support_question.category.${wizardData.categoryId}.${row.id}`)}</div>)}

  </MainPageLayout>
}
